// Domaines et listes de types pour « Prestations de service » et « Développement informatique »
// Classes Tailwind statiques (purge-safe).

export const SERVICE_GROUPS = [
  {
    key: "soins",
    label: "Soins et Consultation",
    badge: "bg-orange-500 text-white",
    soft: "bg-orange-50 text-orange-700 border-orange-200",
    types: [
      "Consultation médicale en ligne",
      "Visioconférence / Formation live",
      "Accompagnement personnalisé",
    ],
  },
  {
    key: "qualite",
    label: "Expertise en Qualité et Accréditation",
    badge: "bg-blue-600 text-white",
    soft: "bg-blue-50 text-blue-700 border-blue-200",
    types: [
      "Expertise en évaluation des pratiques professionnelles (EPP)",
      "Expertise en accréditation des établissements de santé",
      "Expertise en management de l'information hospitalière",
    ],
  },
  {
    key: "donnees",
    label: "Expertise en Données et Recherche",
    badge: "bg-emerald-600 text-white",
    soft: "bg-emerald-50 text-emerald-700 border-emerald-200",
    types: [
      "Expertise en Data analyse",
      "Expertise en Épidémiologie",
      "Expertise en recherche en santé publique (essais cliniques, études observationnelles)",
      "Expertise en Data Sciences et Intelligence Artificielle",
    ],
  },
  {
    key: "ia",
    label: "Intelligence Artificielle et Numérique",
    badge: "bg-violet-600 text-white",
    soft: "bg-violet-50 text-violet-700 border-violet-200",
    types: [
      "Développement d'agent pédagogique IA",
      "Automatisation des tâches par IA",
      "Développement d'applications avec IA",
      "Formation en Intelligence Artificielle appliquée à la santé",
    ],
  },
  {
    key: "autres",
    label: "Autres",
    badge: "bg-slate-500 text-white",
    soft: "bg-slate-100 text-slate-600 border-slate-200",
    types: ["Conseil et expertise personnalisée"],
  },
];

export const SERVICE_FREE_TYPE = "Conseil et expertise personnalisée";

export const DEV_GROUPS = [
  {
    key: "mobile",
    label: "Applications mobiles",
    badge: "bg-blue-800 text-white",
    soft: "bg-blue-50 text-blue-800 border-blue-200",
    types: [
      "Application mobile avec IA (Android / iOS)",
      "Application mobile de gestion médicale avec IA",
      "Application mobile e-commerce avec IA",
      "Application mobile de formation e-learning avec IA",
    ],
  },
  {
    key: "web",
    label: "Sites web",
    badge: "bg-sky-500 text-white",
    soft: "bg-sky-50 text-sky-700 border-sky-200",
    types: [
      "Site web vitrine avec IA",
      "Site web dynamique avec IA",
      "Site web e-commerce avec IA",
      "Site web pour centre hospitalier (vitrine et dynamique)",
      "Plateforme e-learning avec IA (Moodle, BBB)",
      "Portail patient en ligne avec IA",
    ],
  },
  {
    key: "si",
    label: "Systèmes d'information",
    badge: "bg-emerald-600 text-white",
    soft: "bg-emerald-50 text-emerald-700 border-emerald-200",
    types: [
      "Système d'information hospitalier avec IA",
      "Système de gestion de pharmacie avec IA",
      "Système de gestion de laboratoire avec IA",
      "Système de dossier médical électronique avec IA",
    ],
  },
  {
    key: "paiement",
    label: "Paiement et transactions",
    badge: "bg-orange-500 text-white",
    soft: "bg-orange-50 text-orange-700 border-orange-200",
    types: [
      "Système de paiement mobile en ligne",
      "Intégration CinetPay (Orange Money, MTN MoMo, Wave)",
      "Intégration passerelle de paiement internationale",
      "Système de facturation et caisse médicale",
    ],
  },
  {
    key: "expertise",
    label: "Expertise et systèmes spécialisés",
    badge: "bg-violet-600 text-white",
    soft: "bg-violet-50 text-violet-700 border-violet-200",
    types: [
      "Système d'expertise médico-juridique avec IA",
      "Système d'aide à la décision clinique avec IA",
      "Agent IA conversationnel médical (chatbot)",
      "Système d'analyse de données médicales avec IA",
      "Tableau de bord épidémiologique avec IA",
      "Système d'accréditation et d'audit qualité avec IA",
      "Plateforme de gestion des réunions (staffs), séminaires et webinaires en ligne",
      "Plateforme de promotion de la santé (sensibilisation par thèmes)",
      "Plateforme de gestion des téléconsultations et téléexpertises médicales & scientifiques",
    ],
  },
  {
    key: "maintenance",
    label: "Maintenance et support",
    badge: "bg-slate-500 text-white",
    soft: "bg-slate-100 text-slate-600 border-slate-200",
    types: [
      "Maintenance et support d'application existante",
      "Audit et optimisation de système informatique",
      "Formation des équipes à l'utilisation des outils IA",
      "Migration de données vers un nouveau système",
    ],
  },
  {
    key: "autres",
    label: "Autres",
    badge: "bg-slate-400 text-white",
    soft: "bg-slate-100 text-slate-600 border-slate-200",
    types: ["Développement sur mesure"],
  },
];

export const DEV_FREE_TYPE = "Développement sur mesure";

// Retrouve le groupe d'un produit (champ domaine stocké en priorité, sinon mapping par le type)
export function serviceGroupOf(product) {
  const byKey = SERVICE_GROUPS.find((g) => g.key === product.service_domain);
  if (byKey) return byKey;
  return SERVICE_GROUPS.find((g) => g.types.includes(product.service_type)) || null;
}

export function devGroupOf(product) {
  const byKey = DEV_GROUPS.find((g) => g.key === product.dev_domain);
  if (byKey) return byKey;
  return DEV_GROUPS.find((g) => g.types.includes(product.dev_type)) || null;
}

// Le champ « Contexte d'intervention » s'affiche pour les types d'expertise (hors Soins et Consultation)
export function isExpertiseType(type) {
  const g = SERVICE_GROUPS.find((gr) => gr.types.includes(type));
  return !!g && g.key !== "soins";
}

export const DEV_PLATFORMS = [
  ["android", "Android uniquement"],
  ["ios", "iOS uniquement"],
  ["android_ios", "Android + iOS"],
  ["web", "Web uniquement"],
  ["web_mobile", "Web + Mobile"],
];

export const DEV_COMPLEXITIES = [
  ["simple", "Simple (site vitrine, app basique)"],
  ["intermediaire", "Intermédiaire (e-commerce, gestion)"],
  ["complexe", "Complexe (SIH, IA avancée, multi-modules)"],
];

export const DEV_DELAYS = [
  ["moins_1_mois", "Moins d'1 mois"],
  ["1_3_mois", "1 à 3 mois"],
  ["3_6_mois", "3 à 6 mois"],
  ["plus_6_mois", "Plus de 6 mois"],
];

export const DEV_BUDGETS = [
  ["moins_500k", "Moins de 500 000 FCFA"],
  ["500k_2m", "500 000 à 2 000 000 FCFA"],
  ["2m_5m", "2 000 000 à 5 000 000 FCFA"],
  ["plus_5m", "Plus de 5 000 000 FCFA"],
  ["a_definir", "Budget à définir ensemble"],
];

export const DEV_SPECS_STATUS = [
  ["oui", "Oui"],
  ["non", "Non"],
  ["a_elaborer", "À élaborer avec Cabinet CARIS Santé"],
];

export const labelOf = (options, value) => {
  const found = options.find(([k]) => k === value);
  return found ? found[1] : value;
};
